/* Exit intent popup — free ebook (snippets/exit-intent-popup.liquid)
   Desktop: cursor leaves through the top of the window.
   Mobile: a fast scroll back up after reading at least 40% of the page.
   Shown at most once per page view; after a close it waits cooldownHours,
   after a signup it never shows again on this browser.
   Preview: ?popup=preview on any URL, or the theme-editor checkbox, opens it
   straight away and ignores the delay, page/customer rules and storage. */
(function () {
  const popup = document.getElementById('exit-intent-popup');
  const config = window.STATES_EXIT_POPUP;
  if (!popup || !config) return;

  // theme.css styles `body > :not(...)` and sections can be transformed, so
  // the popup lives directly on <body> to keep position: fixed working.
  document.body.appendChild(popup);

  const DISMISSED_KEY = 'mv_exit_popup_dismissed';
  const DONE_KEY = 'mv_exit_popup_done';
  const pageLoadTime = Date.now();
  const preview = config.editorPreview || /[?&]popup=preview(&|$)/.test(window.location.search);
  const dialog = popup.querySelector('[role="dialog"]');
  const steps = popup.querySelectorAll('[data-exit-step]');
  const form = popup.querySelector('.exit-popup__form');
  const input = popup.querySelector('#exit-popup-email');
  const error = popup.querySelector('.exit-popup__error');
  let goal = '';
  let shown = false;
  let lastFocus = null;

  function read(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }

  function write(key, value) {
    try { localStorage.setItem(key, value); } catch (e) { /* private mode */ }
  }

  function track(event, props) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: event }, props));
    if (window.analytics && typeof window.analytics.track === 'function') {
      window.analytics.track(event, props);
    }
  }

  function blocked() {
    if (read(DONE_KEY)) return true;
    const dismissed = parseInt(read(DISMISSED_KEY), 10);
    if (dismissed && (Date.now() - dismissed) / 36e5 < config.cooldownHours) return true;
    // Don't interrupt the quiz or an open cart
    if (document.querySelector('#quiz-overlay.active, #cart-drawer.active')) return true;
    return false;
  }

  function showStep(name) {
    steps.forEach(function (step) { step.hidden = step.dataset.exitStep !== name; });
    const target = popup.querySelector('[data-exit-step="' + name + '"]');
    if (!target) return;
    // Name the dialog after the heading of the step on screen
    const heading = target.querySelector('h2[id]');
    if (heading) dialog.setAttribute('aria-labelledby', heading.id);
    const focusable = target.querySelector('input, button, a');
    if (focusable) focusable.focus();
  }

  // Close button plus the controls of the visible step
  function focusables() {
    return Array.prototype.filter.call(
      dialog.querySelectorAll('button, a[href], input'),
      function (el) { return !el.disabled && !el.closest('[hidden]'); }
    );
  }

  function open(trigger) {
    if (shown) return;
    if (!preview && (Date.now() - pageLoadTime < config.minDelayMs || blocked())) return;
    shown = true;
    lastFocus = document.activeElement;
    popup.hidden = false;
    // Next frame so the fade-in transition runs after display changes
    requestAnimationFrame(function () {
      popup.classList.add('is-active');
      popup.setAttribute('aria-hidden', 'false');
      showStep('goal');
    });
    document.body.style.overflow = 'hidden';
    track('exit_popup_shown', { trigger: trigger });
  }

  function close() {
    if (!popup.classList.contains('is-active')) return;
    popup.classList.remove('is-active');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (!preview && !read(DONE_KEY)) write(DISMISSED_KEY, String(Date.now()));
    setTimeout(function () { popup.hidden = true; }, 300);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    track('exit_popup_closed', { goal: goal });
  }

  popup.querySelectorAll('[data-exit-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });

  document.addEventListener('keydown', function (e) {
    if (!popup.classList.contains('is-active')) return;
    if (e.key === 'Escape') {
      close();
      return;
    }
    // Keep Tab / Shift+Tab inside the dialog
    if (e.key !== 'Tab') return;
    const items = focusables();
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) {
      e.preventDefault();
      first.focus();
    }
  });

  const chapterLine = popup.querySelector('[data-exit-chapter]');

  function toEmailStep() {
    const info = goal && config.goals[goal];
    chapterLine.textContent = info ? info.chapter : config.ebookTitle;
    showStep('email');
  }

  popup.querySelectorAll('[data-goal]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      goal = btn.dataset.goal;
      track('exit_popup_goal', { goal: goal });
      toEmailStep();
    });
  });

  popup.querySelector('[data-exit-skip]').addEventListener('click', function () {
    goal = '';
    track('exit_popup_goal', { goal: 'skipped' });
    toEmailStep();
  });

  function showError(message) {
    error.textContent = message;
    error.hidden = false;
  }

  function showDone(email) {
    popup.querySelector('[data-exit-email]').textContent = email;
    const info = goal && config.goals[goal];
    const cta = popup.querySelector('[data-exit-product]');
    if (info && info.quiz && typeof window.openQuiz === 'function') {
      cta.textContent = 'Find your State in 60 seconds';
      cta.addEventListener('click', function (e) {
        e.preventDefault();
        close();
        window.openQuiz('exit-popup');
      });
    } else if (info && info.url) {
      cta.href = info.url;
      cta.textContent = 'Shop ' + info.name + ' for this';
    }
    showStep('done');
  }

  let submitting = false;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (submitting) return;
    const email = input.value.trim();
    if (!email || !input.checkValidity()) {
      showError('Please enter a valid email address.');
      return;
    }
    error.hidden = true;

    const tags = ['ebook-download', 'exit-popup'];
    if (goal) tags.push('popup-goal-' + goal);
    track('exit_popup_submit', { goal: goal || 'skipped' });

    // Preview never posts, so tests don't create customers or spend Make runs.
    if (preview) {
      showDone(email);
      return;
    }

    submitting = true;
    form.querySelector('[data-exit-tags]').value = tags.join(',');

    // Copy to Make; fire-and-forget (no-cors, keepalive survives the page change).
    try {
      if (config.webhookUrl) {
        const data = new URLSearchParams();
        data.append('email', email);
        data.append('tags', tags.join(','));
        data.append('goal', goal || 'skipped');
        data.append('page_url', window.location.href.split('#')[0]);
        data.append('submitted_at', new Date().toISOString());
        fetch(config.webhookUrl, { method: 'POST', mode: 'no-cors', keepalive: true, body: data }).catch(function () { return null; });
      }
    } catch (err) { /* never break the signup over the webhook */ }

    // Real form post, like the newsletter and the ebook page: Shopify creates
    // the customer and sends the visitor on to the ebook page.
    write(DONE_KEY, '1');
    form.submit();
  });

  if (preview) {
    setTimeout(function () { open('preview'); }, 500);
    return;
  }

  // Excluded page / signed-in customer, or signed up already: no triggers
  if (config.excluded || read(DONE_KEY)) return;

  // Desktop exit intent
  if (window.matchMedia('(pointer: fine)').matches) {
    document.addEventListener('mouseout', function (e) {
      if (e.clientY <= 0 && !e.relatedTarget) open('mouse-exit');
    });
  }

  // Mobile exit intent: read 40%+ of the page, then scroll back up 250px+
  // within 1.5s (pauses between swipes still count)
  if (window.matchMedia('(pointer: coarse)').matches) {
    let maxDepth = 0;
    let anchorY = window.scrollY;
    let anchorTime = Date.now();

    window.addEventListener('scroll', function onScroll() {
      if (shown) {
        window.removeEventListener('scroll', onScroll);
        return;
      }
      const y = window.scrollY;
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollable > 0) maxDepth = Math.max(maxDepth, y / scrollable);

      const now = Date.now();
      if (y >= anchorY || now - anchorTime > 1500) {
        anchorY = y;
        anchorTime = now;
        return;
      }
      if (maxDepth >= 0.4 && anchorY - y >= 250) open('scroll-up');
    }, { passive: true });
  }
})();
